<template>
  <Dialog :title="`Slet medarbejder ${name}?`" confirm="Fortsæt" :confirmDisabled="!endDate" data-testid="confirm-delete-dialog" @close="onClose">
    <template #content>
      <div class="flex items-center w-full">
        <BaseDateInput v-model="endDate" name="endDate" label="Fratrædelsesdato" class="w-full" :errors="errors" required />
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "~/components/dialogs/Dialog";

export default {
  components: { Dialog },

  props: {
    name: String,
  },

  emits: ["close"],

  data() {
    return {
      endDate: null,
      errors: [],
    };
  },

  methods: {
    onClose(accepted) {
      if (accepted && !this.endDate) {
        this.errors = ["Fratrædelsesdato er påkrævet"];
        return;
      }

      this.$emit("close", { accepted, endDate: this.endDate });
    },
  },
};
</script>
